import {ContainerPage} from "../../../../misc/pdf/parts/ContainerPage";
import {TitleTextBlock} from "../../../../misc/pdf/parts/TitleTextBlock";
import {grey} from "@mui/material/colors";

export function ImageTilePage(props: {
    title: string;
    images: string[];
    // optional per-image caption, index-aligned with images. When present, the elevation
    // label (e.g. "STD-A") is drawn as a text footer under each tile instead of being baked
    // into the image (see elevationTool/scenes/export/ExportScene.ts).
    labels?: string[];
    // tag each tile so the print service swaps the chrome-rasterized image back to its
    // full-resolution original after rendering (see core/printing/pdfimage).
    highRes?: boolean;
}) {
    const nPerPage = 6;
    return (
        <>
            {range(0, Math.ceil(props.images.length / nPerPage)-1).map((row) =>
                <ContainerPage key={row.toString()}>
                    <TitleTextBlock title={props.title}>
                        <div style={{display: "flex", flexDirection: "column", flex: 1}}>
                            <div style={{
                                flex: 1,
                                display: "flex", flexDirection: "row",
                            }}>
                                {/* first 3 */}
                                {range(row * nPerPage, row * nPerPage + 2).map((index) =>
                                    <ImageTile key={index.toString()} index={index} images={props.images} labels={props.labels} highRes={props.highRes} />
                                )}
                            </div>
                            <div style={{
                                flex: 1,
                                display: "flex", flexDirection: "row",
                                paddingTop: 8,
                            }}>
                                {/* second 3 */}
                                {range(row * nPerPage + 3, row * nPerPage + 5).map((index) =>
                                    <ImageTile key={index.toString()} index={index} images={props.images} labels={props.labels} highRes={props.highRes} />
                                )}
                            </div>
                        </div>
                    </TitleTextBlock>
                </ContainerPage>
            )}
        </>
    )
}

// one grid cell: the image area auto-scales the drawing to fit (background-size: contain), with
// the label — when supplied — as a centered text footer beneath it.
function ImageTile(props: {
    index: number;
    images: string[];
    labels?: string[];
    highRes?: boolean;
}) {
    const has = props.index < props.images.length;
    const label = props.labels?.[props.index];

    return (
        <div style={{
            width: "33%",
            height: "100%",
            display: "flex", flexDirection: "column",
            paddingLeft: 4,
            paddingRight: 4,
        }}>
            <div
                data-pdf-image-high-res={props.highRes && has ? "true" : undefined}
                style={{
                flex: 1,
                minHeight: 0,
                border: has ? "1px solid " + grey["200"] : "none",
                backgroundImage: has ? "url(" + props.images[props.index] + ")" : "none",
                backgroundSize: "contain",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
            }} />
            {has && label && <div style={{
                textAlign: "center",
                paddingTop: 4,
                fontSize: 12,
            }}>{label}</div>}
        </div>
    );
}

function range(start: number, end: number) {
    let list: number[] = [];

    for(let i = start; i <= end; i++) {
        list.push(i)
    }

    return list;
}
